"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var authorDeliveryMethods = [
    {
        delivery_uid: 0,
        type: 'Self-Study'
    },
    {
        delivery_uid: 1,
        type: 'Group-Live'
    },
    {
        delivery_uid: 2,
        type: 'Group-Internet / Webinar'
    },
    {
        delivery_uid: 8,
        type: 'QAS Self-Study'
    },
    {
        delivery_uid: 9,
        type: 'Nano-Learning'
    },
    {
        delivery_uid: 10,
        type: 'Blended Learning (Group-Live)'
    },
    {
        delivery_uid: 11,
        type: 'Blended Learning (Group-Internet)'
    }
];
exports.authorDeliveryMethods = authorDeliveryMethods;
//# sourceMappingURL=authorDeliveryMethods.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@prolaera/library/dist/authorDeliveryMethods.js
// module id = 865
// module chunks = 0